export interface ImageSelectorProps {
  data: any;
  closeModal: (key: string) => void;
  onSelectImage: (selectedImage: {
    url: string;
    imageWidth: number;
    imageHeight: number;
  }) => void;
  saveToGallery?: boolean;
  allowAIGeneration?: boolean;
  allowUpload?: boolean;
  allowURL?: boolean;
  allowGallery?: boolean;
  articleTitle?: string;
  articleDescription?: string;
  userPreferences?: any;
  aiGenerateImageClick?: (preferences?: any) => void;
  uploadImage?: (file: File) => void;
  closeButtonText?: string;
  size?: any;
  contentType?: 'article' | 'event' | 'scheduled-image';
  locationKey?: string;
}

export interface ImageItem {
  imageId: string;
  uploadUrl: string;
  cdnUrl: string;
  width: number;
  height: number;
  colors: string[];
  isSelected?: boolean;
}

export interface ImageSelectorState {
  activeTab: 'gallery' | 'upload' | 'url' | 'ai';
  isLoading: boolean;
  isSaving: boolean;
  errorMessage: string;
  selectedImageId: string;
  saveToGalleryChecked: boolean;
  
  // Gallery tab
  imagesList: ImageItem[];
  
  // URL tab  
  sourceUrl: string;
  validUrl: boolean;
  sourceErrorMessage: string;
  
  // Upload tab
  isUploading: boolean;
  uploadProgress: number;
  uploadedImageData: { url: string; width: number; height: number; file: File } | null;
  
  // AI tab
  isGeneratingAI: boolean;
  aiPrompt: string;
  selectedDimensions: { width: number; height: number; label: string };
  userImagePreferences: any[];
  selectedImagePreference: any;
  customOptions: any;
  generatedImages: { url: string; width: number; height: number; imageId?: string; timestamp: number }[];
  selectedGeneratedImageIndex: number;
}

export const DIMENSION_PRESETS = [
  { width: 1792, height: 1024, label: 'Wide' },
  { width: 1024, height: 1024, label: 'Square' },
  { width: 1024, height: 1792, label: 'Tall' },
];